import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Container, Row, Col, Form } from "react-bootstrap";
import { Link, useNavigate } from 'react-router-dom';
import * as AuthVerify from '../../lib/common';
import { Formik } from "formik";
import * as Yup from "yup";
import InputField from "../InputField/InputField";
import { BASE_URL } from '../../lib/constant';
import Axios from '../../lib/axios/axiosInstance';
import Modal from 'react-bootstrap/Modal';
import { Slide, toast } from 'react-toastify';
import Loader from '../Common/loader';
import SlectInputField from "../SlectInputField/SlectInputField";
import CustomDateTimePicker from '../InputField/CustomDateTimePicker';

const PunchoutOrderDetails = ({ refnum }) => {
    const navigate = useNavigate();
    const [cartDetails, setCartDetails] = useState(false);
    const [userDetails, setUserDetails] = useState(false);
    const [showConfirmButton, setShowConfirmButton] = useState(false);
    const [costcenters, setCostCenters] = useState([]);
    const [requestors, setRequestors] = useState([]);
    const [addresses, setAddresses] = useState([]);
    const [fulladdresses, setFullAddress] = useState([]);
    const [selectedAddress, setSelectedAddress] = useState(null);
    const [deldate, setDeldate] = useState(null);

    const getDateTime = () => {
        const today = new Date();
        const yyyy = today.getFullYear();
        let mm = today.getMonth() + 1; // Months start at 0!
        let dd = today.getDate();

        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;

        const formattedToday = dd + '-' + mm + '-' + yyyy;
        return formattedToday;
    }

    const confirmOrderHandler = async (formValues) => {
        console.log(formValues);
        var values = cartDetails;
        // const selectedShippingAddress= addressDetails.filter(x=>x.dellocname==shippingAddress)[0];
        const refnum = values.carth.refnum;
        const val = {
            carth: {
                refnum: refnum,
                billaddr1: values.carth.billaddr1,
                billaddr2: values.carth.billaddr2,
                billaddr3: null,
                billcity: values.carth.billcity,
                billcountry: values.carth.billcountry,
                billstate: values.carth.billstate,
                billpostcode: values.carth.billpostcode,
                billphone: values.carth.billphone,
                billemail: values.carth.billemail,
                shipptc: values.carth.shipptc,
                shipemail: values.carth.shipemail,
                shipphone: values.carth.shipphone,
                shipaddr1: selectedAddress.addr1,
                shipaddr2: selectedAddress.addr2,
                shipaddr3: null,
                shipcity: selectedAddress.city,
                shipcountry: selectedAddress.country,
                shipstate: selectedAddress.state,
                shippostcode: selectedAddress.postcode,
                orderremark1: values.carth.orderremark1,
                billptc: formValues.reqName,
                shipptc: values.carth.shipptc,
                items: values.items,
                ponum: values.carth.ponum,
                budgetnum: values.carth.budgetnum,
                paymode: values.paymodes[0].varid,
                shipmode: values.carth.shipmode,
                allowpartial: values.carth.allowpartial,
                shipdeldateremark: values.carth.shipdeldateremark,
                ccnum: formValues.ccnum,
                shipclocnum: formValues.shipclocnum,
                shipdeldate: deldate
            }
        }
        console.log(val)

        await Axios.post(`/cart/confirmPO/${refnum}`, val)
            .then(async (refnum) => {
                if (refnum?.data && refnum.status == 200) {
                    toast.success('Order Confirmed Successfully !', {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 3000,
                        transition: Slide,
                    });
                    navigate('/my-account?activeKey=Orders')
                } else {
                    let toastMsg = "";
                    refnum?.data.errordetail.map(error => {
                        toastMsg += error.error + "\n"
                    })
                    toast.success(toastMsg, {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 3000,
                        transition: Slide,
                    });
                }
            })
            .catch(e => {
                console.log(e)
            });
    }

    useEffect(() => {
        const getOrderDetails = async () => {
            console.log(refnum)
            return await Axios.get(`/cart/cartdetails/${refnum}`)
                .then((cartDetails) => {
                    if (cartDetails?.data && cartDetails.status == 200) {
                        setCartDetails(cartDetails.data);

                        let varSpecificdate = cartDetails.data?.shipdeldatesettings[0].specificdate ?? cartDetails.data?.shipdeldatesettings[0].defaultdate;
                        setDeldate(varSpecificdate?.split('T')[0]);
                    }
                    else {
                        //error
                    }
                })
        }

        const getCostCenter = async () => {
            await Axios.get('/account/costcenter/')
                .then((response) => {
                    if (response.data?.data && response.status == 200) {
                        let costcenters = []
                        for (let i = 0; i < response.data.data.length; i++) {
                            costcenters.push({ value: response.data.data[i].ccnum, label: response.data.data[i].ccname })
                        }
                        setCostCenters(costcenters);
                    }
                    else {
                        setCostCenters([]);
                    }
                })
        }

        getOrderDetails();
        getCostCenter();
        setUserDetails(AuthVerify.getUser());
    }, []);

    const handleChangeCcnum = async (e, setFieldValue) => {
        setFieldValue("reqName", '');
        setFieldValue("shipclocnum", '');
        let ccnum = e.target.value;
        await Axios.get(`/corporate/costcenter/${userDetails.arnum}/${ccnum}`)
            .then((response) => {
                if (response?.data && response.status == 200) {
                    console.log(response.data.data.purchasers)
                    let requestors = []
                    for (let i = 0; i < response.data.data.purchasers.length; i++) {
                        requestors.push({ value: response.data.data.purchasers[i].username, label: response.data.data.purchasers[i].username })
                    }
                    setRequestors(requestors)

                    setFullAddress(response.data.data.addresses);
                    let addresses = []
                    for (let i = 0; i < response.data.data.addresses.length; i++) {
                        addresses.push({ value: response.data.data.addresses[i].clocnum, label: response.data.data.addresses[i].dellocname })
                    }
                    setAddresses(addresses)
                }
                else {
                    setRequestors([]);
                    setAddresses([])
                }
            })
    }

    const handleChangeLocation = async (e) => {
        let selectedShippingLocation = fulladdresses.filter(x => x.clocnum == e.target.value)
        setSelectedAddress(selectedShippingLocation[0]);
    }

    return (
        <section className="main-container col1-layout">
            <Container className="main">
                <div className="col-main">
                    <div className="shopping-cart-inner">
                        <div className="page-title">
                        </div>
                        <div className="page-content">
                            <div className="page-content checkout-page">
                                <div className="box-border">
                                    <h2>{"Order Summary"}</h2>
                                    <h3 className="checkout-sep" style={{ paddingBottom: "10px" }}>NO : {cartDetails?.carth?.refnum}</h3>
                                    {cartDetails?.carth?.trandate && <h5><strong>Order Date:</strong> {cartDetails?.carth?.trandate ? (new Date(cartDetails.carth.trandate)).toLocaleDateString(undefined, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }) : getDateTime()}</h5>}
                                    <h5><strong>Status:</strong> {cartDetails?.carth?.statusdisplay}</h5>
                                    <br />
                                    <div className="order-detail-content table-responsive">
                                        <table className="table table-bordered jtv-cart-summary">
                                            <thead>
                                                <tr>
                                                    <th className="cart_product">Product</th>
                                                    <th>Description</th>
                                                    <th>Unit price</th>
                                                    <th>Qty</th>
                                                    <th>Total</th>
                                                </tr>
                                            </thead>
                                            {cartDetails && cartDetails.carth && cartDetails.items ?
                                                <>
                                                    <tbody>

                                                        {cartDetails.items.map((item, i) => {
                                                            return (
                                                                <tr key={i}>
                                                                    <td className="cart_product"><Link to="/order-details">
                                                                        <img src={AuthVerify.getImageLink(item?.imageurl)} alt="Product" style={{ maxHeight: "100px" }} /></Link></td>
                                                                    <td className="cart_description"><p className="product-name"><Link to={"/product-detail?matnum=" + item?.matnum}> {item?.matname}</Link>{item?.amended && <sup style={{ color: "red" }}>*amended</sup>}</p>
                                                                        <small className="cart_ref">SKU No.: {item.matnum}</small><br />
                                                                        {/* <small><Link to={AuthVerify.getImageLink(item.imageurl)}>Color : White</Link></small>*/}<br /></td>
                                                                    <td className="price"><span>S${item.uprice}</span></td>
                                                                    <td className="qty">{item.qty}
                                                                    </td>
                                                                    <td className="price"><span>S${item.amt}</span></td>
                                                                </tr>)
                                                        })}
                                                    </tbody>

                                                    <tfoot>
                                                        <tr>
                                                            <td colSpan="2" rowSpan="5">
                                                                <div className="input-group mb-3" style={{
                                                                    display: "flex", width: "80%"
                                                                }}>
                                                                    <input type="text" id="coupon" name="coupon" title="coupon" className="input form-control"
                                                                        placeholder="No Promo Code Applied"
                                                                        value={cartDetails?.carth?.promocode}
                                                                        readOnly={true}
                                                                        style={{
                                                                            marginTop: "0px",
                                                                            marginRight: "0px",
                                                                            padding: "0px"
                                                                        }} />
                                                                </div>
                                                            </td>
                                                            <td colSpan="2">Subtotal</td>
                                                            <td colSpan="1">S${(cartDetails?.carth?.grossamt ?? 0).toFixed(2)}</td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan="2"><strong>Discount</strong></td>
                                                            <td colSpan="1"><strong>S${(cartDetails?.carth?.discamt ?? 0).toFixed(2)}</strong></td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan="2"><strong>Shipping Amount</strong></td>
                                                            <td colSpan="1"><strong>S${(cartDetails?.carth?.shippingamt ?? 0).toFixed(2)}</strong></td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan="2"><strong>GST</strong></td>
                                                            <td colSpan="1"><strong>S${(cartDetails?.carth?.gstamt ?? 0).toFixed(2)}</strong></td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan="2"><strong>Grand Total</strong></td>
                                                            <td colSpan="1"><strong>S${(cartDetails?.carth?.totalamt ?? 0).toFixed(2)}</strong></td>
                                                        </tr>
                                                    </tfoot>
                                                </> :
                                                <tr>
                                                    {cartDetails.items != null ? <td colSpan="6"><Loader /></td> : <td colSpan="6" style={{ textAlign: 'center' }}>No products found !</td>}
                                                </tr>
                                            }
                                        </table>
                                    </div>
                                </div>

                                <div className="box-border">
                                    <div className="box-account">
                                        <div className="page-title">
                                            <h2>Shipping Request Information</h2>
                                        </div>
                                        <br />
                                        <p>{cartDetails?.carth?.po_shipinfo}</p>
                                        <hr />
                                    </div>
                                    <div className="box-account">
                                        <div className="page-title">
                                            <h2>Processor please fill up information below to submit order to ERP:</h2>
                                            <div className="col2-set">
                                                <div className="col-1">
                                                    <h5>Billing Address</h5>
                                                    <address>
                                                        {cartDetails?.carth?.billaddr1}<br />
                                                        {cartDetails?.carth?.billcountry}<br />
                                                        {cartDetails?.carth?.billpostcode} <br />
                                                        {/* <Link to="/order-details">Edit</Link> */}
                                                    </address>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <Formik
                                        initialValues={{
                                            ccnum: null,
                                            reqName: null,
                                            shipclocnum: null
                                        }}
                                        validate={(values) => {
                                            let errors = {};
                                            if (!values.ccnum || values.ccnum == '') {
                                                errors.ccnum = "Cost Center is required";
                                            }
                                            if (!values.reqName || values.reqName == '') {
                                                errors.reqName = "Requestor is required";
                                            }
                                            if (!values.shipclocnum || values.shipclocnum == '') {
                                                errors.shipclocnum = "Location is required";
                                            }
                                            if (!deldate) {
                                                errors.deldate = "Delivery Date is required";
                                            }

                                            return errors;
                                        }}
                                        onSubmit={(values, { setSubmitting, resetForm }) => {
                                            setSubmitting(false);
                                            confirmOrderHandler(values);
                                        }}
                                    >
                                        {(props) => {
                                            const {
                                                values,
                                                setFieldValue,
                                                handleChange,
                                                handleBlur,
                                                handleSubmit,
                                                isSubmitting,
                                                errors, touched
                                            } = props;
                                            return (
                                                <Form onSubmit={handleSubmit}>
                                                    <Row>
                                                        <Col sm={6}>
                                                            <div className="custom_select">
                                                                <SlectInputField
                                                                    Labels="Cost Center"
                                                                    Name="ccnum"
                                                                    placeHolder="Select Cost Center"
                                                                    emptySelection={{ value: '', label: 'Select Cost Center' }}
                                                                    options={costcenters}
                                                                    // value={values.country1}
                                                                    value={values.ccnum}
                                                                    onChange={e => { handleChange(e); handleChangeCcnum(e, setFieldValue) }}
                                                                    onBlur={handleBlur}
                                                                    className={
                                                                        (errors.ccnum && touched.ccnum
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }
                                                                />
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col sm={6}>
                                                            <div className="custom_select">
                                                                <SlectInputField
                                                                    Labels="Requestor"
                                                                    Name="reqName"
                                                                    placeHolder="Select Requestor"
                                                                    emptySelection={{ value: '', label: 'Select Requestor' }}
                                                                    options={requestors}
                                                                    value={values.reqName}
                                                                    onChange={e => { handleChange(e); }}
                                                                    onBlur={handleBlur}
                                                                    className={
                                                                        (errors.reqName && touched.reqName
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }
                                                                />
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col sm={6}>
                                                            <div className="custom_select">
                                                                <SlectInputField
                                                                    Labels="Shipping Location"
                                                                    Name="shipclocnum"
                                                                    placeHolder="Select Location"
                                                                    emptySelection={{ value: '', label: 'Select Location' }}
                                                                    options={addresses}
                                                                    value={values.shipclocnum}
                                                                    onChange={e => { handleChange(e); handleChangeLocation(e) }}
                                                                    onBlur={handleBlur}
                                                                    className={
                                                                        (errors.shipclocnum && touched.shipclocnum
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }
                                                                />
                                                            </div>
                                                            <address>
                                                                {selectedAddress?.addr1}<br />
                                                                {selectedAddress?.addr2}<br />
                                                                {selectedAddress?.postcode} <br />
                                                            </address>
                                                        </Col>
                                                    </Row>
                                                    <div className="box-account">
                                                        {userDetails?.role === 'Corporate' &&
                                                            <>
                                                                <Row>
                                                                    <Col md={12}>
                                                                        <h2>PO Information</h2>
                                                                        <Col md={3}>
                                                                            PO No.
                                                                        </Col>
                                                                        <Col md={3}>
                                                                            <input
                                                                                Type="text"
                                                                                class="form-control"
                                                                                readOnly={true}
                                                                                value={cartDetails?.carth?.ponum}
                                                                            />
                                                                        </Col>
                                                                        <Col md={3}>
                                                                            Description
                                                                        </Col>
                                                                        <Col md={3}>
                                                                            <input
                                                                                Type="text"
                                                                                readOnly={true}
                                                                                class="form-control"
                                                                                value={cartDetails?.carth?.podescription}
                                                                            />
                                                                        </Col>
                                                                    </Col>
                                                                </Row>
                                                                <hr />
                                                                <Row>
                                                                    {cartDetails.carth?.shipdeldatedisplay && <>
                                                                        <Col md={12}>
                                                                            <h2>Delivery Date</h2>
                                                                            <Col md={3}>
                                                                                Select Date
                                                                            </Col>
                                                                            <Col md={3}>
                                                                                <CustomDateTimePicker
                                                                                    value={deldate ? new Date(deldate) : false}
                                                                                    onChange={(e) => { handleChange({ type: "change", target: { value: e } }); console.log(e); setDeldate(new Date(e)); }}
                                                                                    minDate={cartDetails?.shipdeldatesettings ? new Date(cartDetails?.shipdeldatesettings[0].mindate) : false}
                                                                                    className={(errors.deldate && touched.deldate) ? 'is-invalid' : 'form-control'}
                                                                                />
                                                                                {errors.deldate ? (
                                                                                    <>
                                                                                        <span
                                                                                            style={{
                                                                                                color: "red",
                                                                                            }}
                                                                                        >
                                                                                            {errors.deldate}{" "}
                                                                                        </span>
                                                                                        <br />
                                                                                    </>
                                                                                ) : (
                                                                                    ""
                                                                                )
                                                                                }
                                                                            </Col>
                                                                        </Col>
                                                                    </>}
                                                                    {cartDetails.carth?.shipdeldatedisplay && cartDetails.carth?.shipdeldatemessage &&
                                                                        <Col sm={12} className="heading-counter warning text-center" style={{ color: "#f5c328", fontWeight: "bold" }}>
                                                                            <span>
                                                                                {cartDetails.carth?.shipdeldatemessage}.
                                                                            </span>
                                                                        </Col>
                                                                    }
                                                                </Row>
                                                            </>
                                                        }
                                                        {cartDetails?.carth?.shipdelremark1 &&
                                                            <>
                                                                <hr />
                                                                <h2>Remarks</h2>
                                                                <div className="col2-set">
                                                                    <div className="col-1">
                                                                        <p><strong>Order Remarks : </strong>{cartDetails?.carth?.shipdelremark1 ?? 'N/A'}<br /><br />
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        }
                                                        <div className="cart_navigation" style={{ marginBottom: '10px' }}>
                                                            {refnum &&
                                                                <Link to='/' style={{ padding: '0', border: 'none' }}>
                                                                    <button className="button btn-proceed-checkout" title="Back to Home" type="button"><span>Back to Home</span></button>
                                                                </Link>
                                                            }
                                                            <button
                                                                className="button btn-proceed-checkout"
                                                                title="Proceed to Submit"
                                                                type="submit"
                                                                disabled={isSubmitting}
                                                            >
                                                                <span>Confirm Order</span></button>

                                                        </div>
                                                    </div>
                                                </Form>
                                            )
                                        }}
                                    </Formik>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Container >
        </section >
    )
}
export default PunchoutOrderDetails;

